var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_820_894)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.667 10.0664H21.333C21.3445 10.0664 21.3562 10.0695 21.3662 10.0752C21.3762 10.0809 21.3847 10.0898 21.3906 10.0996V10.0986L23.3906 13.4326C23.3968 13.4429 23.4004 13.4548 23.4004 13.4668V13.4688C23.4014 13.8678 23.2861 14.2587 23.0693 14.5938C22.8526 14.9288 22.5432 15.1938 22.1787 15.3564C21.8143 15.519 21.4107 15.5721 21.0166 15.5098C20.6224 15.4473 20.2544 15.2722 19.958 15.0049L19.5557 14.6416L19.1533 15.0049C18.7763 15.3462 18.2859 15.536 17.7773 15.5361C17.2687 15.5361 16.7775 15.3463 16.4004 15.0049L15.998 14.6406L15.5957 15.0049C15.2188 15.3456 14.7288 15.5342 14.2207 15.5342C13.7126 15.5342 13.2226 15.3456 12.8457 15.0049L12.4434 14.6416L12.041 15.0049C11.663 15.3463 11.1714 15.5345 10.6621 15.5332H10.6572C10.1108 15.5318 9.58683 15.3139 9.20117 14.9268C8.81548 14.5394 8.59865 14.0144 8.59961 13.4678V13.4668L8.60938 13.4326L10.6084 10.0986L10.6094 10.0996C10.6153 10.0898 10.6238 10.0809 10.6338 10.0752C10.6438 10.0695 10.6555 10.0664 10.667 10.0664Z",
    stroke: "#596CFF",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5576 17.7073C20.1225 17.9445 20.7301 18.0671 21.3447 18.0667H21.3516C21.3677 18.0664 21.3842 18.0651 21.4004 18.0647V24.1331C21.4004 24.1507 21.3933 24.1684 21.3809 24.1809C21.3684 24.1934 21.3507 24.2004 21.333 24.2004H17.9336V20.2004H14.0664V24.2004H10.667C10.6493 24.2004 10.6316 24.1934 10.6191 24.1809C10.6067 24.1684 10.5996 24.1507 10.5996 24.1331V18.0647C10.6181 18.0651 10.6368 18.0665 10.6553 18.0667H10.6592C11.2725 18.0677 11.8786 17.9446 12.4424 17.7083C12.546 17.7517 12.6512 17.7915 12.7578 17.8274C13.3279 18.021 13.9305 18.1005 14.5312 18.0598C15.0373 18.0255 15.5331 17.9054 15.999 17.7083C16.1027 17.7517 16.2079 17.7925 16.3145 17.8284V17.8274C16.8847 18.0205 17.4872 18.0996 18.0879 18.0588C18.5946 18.0244 19.0911 17.9047 19.5576 17.7073Z",
    stroke: "#596CFF",
    strokeWidth: 1.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_820_894"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(8 8.80005)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/dashboard-icon.7990ddb8daf083965215afba84939c53.svg";
export { ForwardRef as ReactComponent };